import { GearPage } from "../components/GearPage";
import { HEROES, BEACH_GEAR } from "../data/gear";

export default function BeachGear({ onQuote }) {
  return (
    <GearPage
      testid="beach-gear-page"
      hero={HEROES.beach}
      eyebrow="Beach Gear Rentals"
      title="Everything for the perfect beach day"
      intro="Beach chairs, sun umbrellas, string lights, firepits and silent power stations — delivered and set up on the sand."
      banner="✓ Delivered, set up & collected — we handle it all"
      gear={BEACH_GEAR}
      onQuote={onQuote}
    />
  );
}
